import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { QrCodeImg } from './DetailPage';

interface Iprops {
  data: string;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * QRCode 區塊。
 */
const InfoQrCode: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType }) => {
  const angleColor = colorType.fifth;
  const url = 'data:image/png;base64,' + data;
  return (
    <DropdownInfo title={`QR code`} isShow={isShow} setIsShow={setIsShow} color={angleColor}>
      <QrCodeImg src={url} alt="QR code圖片" />
    </DropdownInfo>
  );
};

export default InfoQrCode;
